export function isSafariBrowser() {
  if (typeof navigator === 'undefined') {
    return false;
  }

  return /Safari/i.test(navigator.userAgent) && !/Chrome|CriOS|FxiOS|EdgiOS/i.test(navigator.userAgent);
}

export function isAppleMobileBrowser() {
  if (typeof navigator === 'undefined') {
    return false;
  }

  return /iPhone|iPad|iPod/i.test(navigator.userAgent);
}

export function getViewportHeight() {
  if (typeof window === 'undefined') {
    return 0;
  }

  return window.visualViewport?.height ?? window.innerHeight;
}
